import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0762bbca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "GameLibrary" }
const _hoisted_2 = {
  key: 0,
  class: "show-search-page"
}
const _hoisted_3 = { class: "tips" }
const _hoisted_4 = { class: "result" }
const _hoisted_5 = { class: "tag-list-box" }
const _hoisted_6 = ["title", "onClick"]
const _hoisted_7 = {
  key: 1,
  class: "gameLibrary-loading"
}
const _hoisted_8 = {
  key: 2,
  class: "empty-data"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Game Not Found", -1))
const _hoisted_10 = { class: "gameLibrary-list" }
const _hoisted_11 = ["onClick", "title"]
const _hoisted_12 = { class: "img" }
const _hoisted_13 = { alt: "" }
const _hoisted_14 = { class: "game-name ellipsis" }
const _hoisted_15 = { class: "game-tag-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSvga = _resolveComponent("AppSvga")!
  const _component_CusModal = _resolveComponent("CusModal")!
  const _component_SelectGameModal = _resolveComponent("SelectGameModal")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isShowSearchPage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(`Search results for "${_ctx.route.query?.search}"`), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.searchResultList.length) + " related games found ", 1)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTags, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["tag-list-item", { active: _ctx.currentTagId === item.tag }]),
            key: item.tag,
            title: item.name,
            onClick: ($event: any) => (_ctx.selectTag(item.tag))
          }, _toDisplayString(item.name), 11, _hoisted_6))
        }), 128))
      ], 512), [
        [_vShow, !_ctx.isShowSearchPage]
      ]),
      (_ctx.loadingPage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_AppSvga, {
              class: "loading-svga",
              src: require('@img/loading.svga')
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.loadingPage && !_ctx.getListByIsShowSearchPage.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_AppSvga, {
              class: "empty-svga",
              src: require('@img/empty.svga')
            }, null, 8, ["src"]),
            _hoisted_9
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getListByIsShowSearchPage, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.communityId,
            onClick: ($event: any) => (_ctx.selectGame(item)),
            title: item.name
          }, [
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [
                [_directive_lazy, item.icon]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags, (tags) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "game-tag-item",
                  key: tags.id
                }, _toDisplayString(tags.name), 1))
              }), 128))
            ])
          ], 8, _hoisted_11))
        }), 128))
      ])
    ]),
    _createVNode(_component_CusModal, {
      isShow: _ctx.showCoinNotEnoughModal,
      title: "",
      content: _ctx.$t('showCoinNotEnoughModal.content'),
      cancelText: _ctx.$t('showCoinNotEnoughModal.later'),
      okText: _ctx.$t('Payment.recharge'),
      onOnCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleChangeCoinNotEnoughModal(false))),
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChangeCoinNotEnoughModal(false))),
      onOnConfirm: _ctx.handleShowRecharge
    }, null, 8, ["isShow", "content", "cancelText", "okText", "onOnConfirm"]),
    _createVNode(_component_SelectGameModal, {
      communityId: _ctx.communityId,
      onSelectGameModelClose: _ctx.selectGameModelClose
    }, null, 8, ["communityId", "onSelectGameModelClose"])
  ], 64))
}